import { labeled, numberRequired, selectionRequired, stringRequired } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    cost: numberRequired(Joi, 1).label(labeled(label, 'Asset Cost')),
    vehicle: Joi.object().keys({
      year: numberRequired(Joi, 1).label(labeled(label, 'Asset Year'))
    }),
    type: selectionRequired(Joi, 1, 44).label(labeled(label, 'Asset Type')),
    assetLocation: stringRequired(Joi, 1, 3).label(labeled(label, 'Asset Location'))
  });

export default {
  schema
};
